/* ── GESTURE step boxes, drawn rather than filmed ───────────────────────
   Three canvases reproducing Harmonic's own widgets: the GESTURE button through
   its whole life, and the fader column being performed and then playing back.

   WHY THIS IS A REDRAW AND NOT FOOTAGE. Harmonic's paint path is pure vector —
   the gesture icon is fillEllipse plus a stroked arc, the faders are
   fillRoundedRectangle, and there is no drawImage or ImageCache anywhere in it.
   That is the same situation as the Texture hero, and the opposite of Delay and
   Mood, which composite megabytes of painted PNGs and can never be reproduced
   with strokes.

   THE THREE BUTTON STATES ARE THE PLUG-IN'S, NOT INVENTED (PluginEditor.cpp,
   the gesture branch of the menu-bar icon):
     idle       green outline ring, r
     recording  red dot at r, plus a countdown arc at r+9 whose sweep is
                remaining * twoPi starting from -halfPi
     playing    white dot at 0.17r, plus a 90-degree arc orbiting at 0.4r
   The plug-in draws these at r=3.6. Box 01 runs all three in sequence, because
   the button IS the legend for the whole feature and the playing state appears
   nowhere else on the page.

   BOX 01 IS THE BUTTON, FILLING THE FRAME. It used to be a wide shot of the
   header: a panel-corner stroke, a RESET label, a DEPTH 0% strip along the
   bottom, and the button itself at r=15 somewhere in the middle. Next to boxes
   02 and 03, which are dense columns of labelled faders, it read as ninety per
   cent empty space and the state changes were too small to see, which defeated
   the only reason the box exists. The set dressing is gone and the button is
   drawn at r=54, centred, with its state named underneath. Do not put the
   header furniture back: the box has one job, which is to teach three states.

   The state word is this page's, not the plug-in's. The plug-in shows state
   only through the icon, but at a glance on a landing page a reader needs the
   noun, and LOOPING is what the section headline promises.

   EVERY NUMBER IN BOXES 02 AND 03 WAS MEASURED OFF A REAL FRAME and diffed
   against the plug-in side by side. If you change one, check it the same way.
   The track corner radius is the giveaway: these are rounded rectangles at r=9,
   NOT pills at r=h/2, and pills read as fake instantly.

   Geometry lives in a fixed 500x480 space. The backing store is scaled by
   devicePixelRatio and the context pre-scaled, so drawing code stays in that
   space and stays sharp on any display.

   Lane motion is out-and-back inside each lane's window: every value ends the
   cycle exactly where it started, which is what lets the loop run without a
   jump. Boxes 02 and 03 share one motion function on purpose — that is the
   whole point of the pair.  */
(function () {
  var HOSTS = [].slice.call(document.querySelectorAll('canvas.ev-gcv'));
  if (!HOSTS.length) return;

  var W = 500, H = 480;
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  var BG0 = '#15122B', BG1 = '#1A1636';
  var MARK = 'rgba(198,206,220,0.92)';
  var LANES = [
    { name: 'SHIMMER',  col: '#3BE88A', base: 0.00, peak: 0.00, w0: 0,    w1: 0    },
    { name: 'THICKEN',  col: '#5BE3F0', base: 0.02, peak: 0.85, w0: 0.06, w1: 0.30 },
    { name: 'MOVEMENT', col: '#3E6DFF', base: 0.00, peak: 0.62, w0: 0.30, w1: 0.52 },
    { name: 'DISTANCE', col: '#9B6BFF', base: 0.23, peak: 0.78, w0: 0.52, w1: 0.74 },
    { name: 'GLIDE',    col: '#F04DC8', base: 0.77, peak: 0.14, w0: 0.74, w1: 0.98 }
  ];
  var ROW_Y = 30, PITCH = 94, TRK_X = 22, TRK_W = 456, TRK_H = 40, TRK_DY = 30, TRK_R = 9;

  /* box 01's timeline, in seconds */
  var T_IDLE = 1.6, T_REC = 10, T_PLAY = 5.2;
  var ARM_CYCLE = T_IDLE + T_REC + T_PLAY;

  function smooth(t) { return t * t * (3 - 2 * t); }

  function laneValue(L, t) {
    if (L.w1 <= L.w0) return L.base;
    if (t < L.w0 || t > L.w1) return L.base;
    var u = (t - L.w0) / (L.w1 - L.w0);
    if (u < 0.45) return L.base + (L.peak - L.base) * smooth(u / 0.45);
    if (u < 0.65) return L.peak;
    return L.peak + (L.base - L.peak) * smooth((u - 0.65) / 0.35);
  }

  /* Canvas letterSpacing is too new to rely on in Safari, so space it by hand. */
  function spaced(c, txt, x, y, sp, align) {
    var w = 0, i;
    for (i = 0; i < txt.length; i++) w += c.measureText(txt[i]).width + sp;
    w -= sp;
    var cx = align === 'right' ? x - w : (align === 'center' ? x - w / 2 : x);
    for (i = 0; i < txt.length; i++) {
      c.fillText(txt[i], cx, y);
      cx += c.measureText(txt[i]).width + sp;
    }
    return w;
  }

  function roundRect(c, x, y, w, h, r) {
    c.beginPath();
    c.moveTo(x + r, y);
    c.arcTo(x + w, y,     x + w, y + h, r);
    c.arcTo(x + w, y + h, x,     y + h, r);
    c.arcTo(x,     y + h, x,     y,     r);
    c.arcTo(x,     y,     x + w, y,     r);
    c.closePath();
  }

  function ground(c) {
    var g = c.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, BG0); g.addColorStop(1, BG1);
    c.fillStyle = g; c.fillRect(0, 0, W, H);
    c.fillStyle = 'rgba(255,255,255,0.018)';
    for (var y = 0; y < H; y += 3) c.fillRect(0, y, W, 1);
  }

  function drawFaders(c, t, kind) {
    ground(c);

    c.save();
    c.beginPath(); c.rect(0, 0, W, 16); c.clip();
    roundRect(c, TRK_X, -26, TRK_W, TRK_H, TRK_R);
    c.fillStyle = 'rgba(232,194,74,0.85)'; c.fill();
    c.restore();

    for (var i = 0; i < LANES.length; i++) {
      var L = LANES[i], v = laneValue(L, t);
      var ly = ROW_Y + i * PITCH, ty = ly + TRK_DY;
      var moved = L.w1 > L.w0;

      c.font = '700 25px -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif';
      c.textBaseline = 'alphabetic';
      c.fillStyle = L.col;
      spaced(c, L.name, TRK_X + 2, ly + 20, 1.6, 'left');
      c.globalAlpha = 0.72;
      spaced(c, Math.round(v * 100) + '%', TRK_X + TRK_W - 2, ly + 20, 1.2, 'right');
      c.globalAlpha = 1;

      roundRect(c, TRK_X, ty, TRK_W, TRK_H, TRK_R);
      c.fillStyle = 'rgba(0,0,0,0.34)'; c.fill();
      c.strokeStyle = L.col; c.globalAlpha = 0.30; c.lineWidth = 1.4; c.stroke();
      c.globalAlpha = 1;

      c.save();
      roundRect(c, TRK_X, ty, TRK_W, TRK_H, TRK_R); c.clip();
      c.fillStyle = 'rgba(255,255,255,0.045)';
      for (var sx = TRK_X + 12; sx < TRK_X + TRK_W - 6; sx += 11) c.fillRect(sx, ty + 6, 1.5, TRK_H - 12);

      var fw = Math.max(0, v * (TRK_W - 12));
      if (fw > 1) {
        c.fillStyle = L.col;
        for (var bx = TRK_X + 6; bx < TRK_X + 6 + fw; bx += 11) {
          var bw = Math.min(8, TRK_X + 6 + fw - bx);
          if (bw > 0.5) c.fillRect(bx, ty + 5, bw, TRK_H - 10);
        }
        c.globalAlpha = 0.28; c.fillStyle = '#fff';
        c.fillRect(TRK_X + 6, ty + 5, fw, (TRK_H - 10) * 0.34);
        c.globalAlpha = 1;
      }
      c.restore();

      if (kind === 'loop' && moved) {
        roundRect(c, TRK_X - 3, ty - 3, TRK_W + 6, TRK_H + 6, TRK_R + 3);
        c.strokeStyle = MARK; c.lineWidth = 2.2; c.stroke();
      }
    }

    if (kind === 'perform') drawCursor(c, t);
  }

  function drawCursor(c, t) {
    var L = null, i;
    for (i = 1; i < LANES.length; i++) {
      if (t >= LANES[i].w0 - 0.04 && t <= LANES[i].w1 + 0.02) { L = LANES[i]; break; }
    }
    if (!L) return;
    var v = laneValue(L, t);
    var ty = ROW_Y + LANES.indexOf(L) * PITCH + TRK_DY;
    var x = TRK_X + 6 + v * (TRK_W - 12), y = ty + TRK_H / 2;

    c.save();
    c.translate(x, y);
    c.beginPath();
    c.moveTo(0, 0); c.lineTo(0, 21); c.lineTo(5.4, 16.2);
    c.lineTo(8.8, 23.5); c.lineTo(12.2, 21.8); c.lineTo(8.8, 14.6);
    c.lineTo(15.5, 14.2); c.closePath();
    c.fillStyle = '#fff';
    c.strokeStyle = 'rgba(0,0,0,0.75)'; c.lineWidth = 1.6;
    c.stroke(); c.fill();
    c.restore();
  }

  /* ── box 01: the button alone, idle -> recording -> playing ──
     Every radius here is the plug-in's own ratio against r: the countdown arc
     sits at r*1.6, the recording glow at r*1.53, the playing core at r*0.72 and
     its orbit at r*1.66. Only r itself changed, from 15 to 54. */
  function drawArm(c, t) {
    ground(c);

    var icx = W / 2, icy = 196, r = 54;
    var phase = t < T_IDLE ? 'idle' : (t < T_IDLE + T_REC ? 'rec' : 'play');
    var pulse = 0.5 + 0.5 * Math.sin(t * 6.0);
    var RED = '232,64,79', GRN = '70,214,138', WHT = '236,240,250';
    var tone, state;

    if (phase === 'idle') {
      tone = GRN; state = 'READY';
      c.beginPath(); c.arc(icx, icy, r, 0, Math.PI * 2);
      c.strokeStyle = 'rgba(' + GRN + ',0.75)'; c.lineWidth = 9; c.stroke();

    } else if (phase === 'rec') {
      tone = RED; state = 'RECORDING';
      var remaining = Math.max(0, 1 - (t - T_IDLE) / T_REC);
      c.beginPath(); c.arc(icx, icy, r * 1.53, 0, Math.PI * 2);
      c.fillStyle = 'rgba(' + RED + ',' + (0.14 + pulse * 0.11) + ')'; c.fill();
      c.beginPath(); c.arc(icx, icy, r, 0, Math.PI * 2);
      c.fillStyle = 'rgba(' + RED + ',0.92)'; c.fill();
      c.beginPath(); c.arc(icx, icy, r * 1.6, 0, Math.PI * 2);
      c.strokeStyle = 'rgba(' + RED + ',0.16)'; c.lineWidth = 22; c.stroke();
      if (remaining > 0.001) {
        var sA = -Math.PI / 2, eA = sA + remaining * Math.PI * 2;
        c.beginPath(); c.arc(icx, icy, r * 1.6, sA, eA, false);
        c.strokeStyle = 'rgba(' + RED + ',' + (0.72 + pulse * 0.28) + ')';
        c.lineWidth = 22; c.lineCap = 'round'; c.stroke();
      }

    } else {
      tone = WHT; state = 'LOOPING';
      var spin = (t * Math.PI) % (Math.PI * 2);
      c.beginPath(); c.arc(icx, icy, r * 0.72, 0, Math.PI * 2);
      c.fillStyle = 'rgba(' + WHT + ',0.88)'; c.fill();
      c.beginPath(); c.arc(icx, icy, r * 1.66, 0, Math.PI * 2);
      c.strokeStyle = 'rgba(' + WHT + ',0.12)'; c.lineWidth = 20; c.stroke();
      c.beginPath(); c.arc(icx, icy, r * 1.66, spin, spin + Math.PI / 2, false);
      c.strokeStyle = 'rgba(' + WHT + ',0.9)';
      c.lineWidth = 20; c.lineCap = 'round'; c.stroke();
    }

    c.textBaseline = 'alphabetic';
    c.font = '700 40px -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif';
    c.fillStyle = 'rgba(226,230,242,0.94)';
    spaced(c, 'GESTURE', icx, 350, 4.5, 'center');

    c.font = '700 24px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';
    c.fillStyle = 'rgba(' + tone + ',0.9)';
    spaced(c, state, icx, 404, 4, 'center');
  }

  /* ── driver ── */
  HOSTS.forEach(function (cv) {
    var kind = cv.getAttribute('data-kind');
    var cycle = kind === 'arm' ? ARM_CYCLE : 8;
    var ctx = cv.getContext('2d');
    var dpr = 0, raf = 0, running = false, t0 = null;

    function size() {
      var d = Math.min(window.devicePixelRatio || 1, 2.5);
      if (d === dpr) return;
      dpr = d;
      cv.width = Math.round(W * d); cv.height = Math.round(H * d);
      ctx.setTransform(d, 0, 0, d, 0, 0);
    }

    function paint(t) {
      size();
      if (kind === 'arm') drawArm(ctx, t); else drawFaders(ctx, t / cycle, kind);
    }

    function frame(now) {
      if (!running) { raf = 0; return; }
      if (t0 === null) t0 = now;
      paint(((now - t0) / 1000) % cycle);
      raf = requestAnimationFrame(frame);
    }
    function run(on) {
      running = !!on;
      if (running && !raf) raf = requestAnimationFrame(frame);
    }

    // a representative still, so nothing is ever an empty box
    paint(kind === 'arm' ? T_IDLE + T_REC * 0.45 : cycle * 0.62);
    if (REDUCE) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        run(es[0].isIntersecting && !document.hidden);
      }, { threshold: 0.2 }).observe(cv);
    } else { run(true); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) run(false); });
    window.addEventListener('resize', function () { dpr = 0; paint(0); }, { passive: true });
  });
})();
